import { css } from 'styled-components'

import useShippingAddressForm from 'hooks/shipping/useShippingAddressForm'

import ShippingAddressFormWrapper from 'components/presenters/commerce/order/shippingAddressForm/ShippingAddressFormWrapper'
import ShippingNotice from 'components/presenters/commerce/order/shippingAddressForm/ShippingNotice'
import Zipcode from 'components/presenters/commerce/order/shippingAddressForm/Zipcode'
import SubmitButton from 'components/presenters/commerce/order/shippingAddressForm/SubmitButton'

import Input from 'components/presenters/common/form/Input'
import Button from 'components/presenters/common/form/Button'
import SelectBox from 'components/presenters/common/form/SelectBox'
import Textarea from 'components/presenters/common/form/Textarea'

export default function ShippingAddressForm({ onComplete }) {
  const {
    address,
    zipcode,
    shippingAction,
    isValid,
    openSearchForm,
    handleChangeShippingOption,
    handleChange,
    handleSubmit,
  } = useShippingAddressForm({ onComplete })
  const shippingOptions = [
    { label: '부재시 문앞에 놓아주세요', value: 'frontDoor' },
    { label: '배송전에 미리 연락주세요', value: 'preCall' },
    { label: '부재시 경비실에 맡겨 주세요', value: 'securityOffice' },
    { label: '부재시 전화주시거나 문자 남겨 주세요', value: 'textMsgCall' },
    { label: '직접 입력', value: 'etc' },
  ]
  return (
    <>
      <ShippingAddressFormWrapper>
        <ShippingNotice />
        <Input label="받는사람" name="recipient" onChange={handleChange} placeholder="ex) 홍길동" />
        <Input
          label="휴대폰번호"
          name="phone"
          onChange={handleChange}
          placeholder="'-'없이 입력해주세요"
          wrapperStyle={css`
            margin-top: calc(100vw * (28 / 375));
          `}
        />
        {address === null || zipcode === null ? (
          <Button
            label="우편번호"
            onClick={openSearchForm}
            wrapperStyle={css`
              margin-top: calc(100vw * (28 / 375));
            `}
            fullWidth
          >
            우편번호 검색하기
          </Button>
        ) : (
          <>
            <Zipcode address={address} zipcode={zipcode} onClick={openSearchForm} />
            <Input
              label="상세주소"
              name="detailAddress"
              onChange={handleChange}
              placeholder="상세주소를 입력해주세요"
              wrapperStyle={wrapperStyle}
            />
            <SelectBox
              options={shippingOptions}
              onChange={handleChangeShippingOption}
              placeholder="배송시 요청사항을 선택해주세요"
              size={3}
              theme={(theme) => ({
                ...theme,
                colors: {
                  ...theme.colors,
                  neutral50: '#c6c6c6',
                },
              })}
              isSearchable={false}
              menuPlacement="top"
            />
            {shippingAction?.value === 'etc' && (
              <Textarea
                inputStyle={textareaStyle}
                name="shippingDetail"
                onChange={handleChange}
                placeholder="배송시 요청사항을 적어주세요"
              />
            )}
          </>
        )}
      </ShippingAddressFormWrapper>
      <SubmitButton isValid={isValid} onClick={handleSubmit} />
    </>
  )
}

const wrapperStyle = css`
  margin-top: calc(100vw * (28 / 375));
  margin-bottom: calc(100vw * (15 / 375));
`

const textareaStyle = css`
  border: none;
  background-color: #f7f7f7;
  margin-top: calc(100vw * (15 / 375));
  height: calc(100vw * (82 / 375));
`
